import { FC, useEffect } from 'react';
import { TweenMax } from 'gsap';
import css from './appControl.module.scss';
import { supportLinkLocales } from './const';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import EFVideo from '@/components/UI/EFVideo';

const AppControl: FC = () => {
    const { useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');
    const imageLocal = getImageLocal(locale, ['cn', 'es']);
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationK',
            offset: layoutH * 0.4, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationK .msg-box',
            0.5,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        sceneA1.setTween(tweenA1);
        // @ts-ignore window.controllerDelta2
        controllerDelta2?.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationK} animationK GtmModuleData-section`} data-section-id={css.animationK} data-section-title={t('delta2.aniK_msg2')}>
            <div className="static-box">
                <div className="msg-box">
                    <div className="msg-title1">{t('delta2.aniK_msg1')}</div>
                    <div className="msg-title2 title-bolder">{t('delta2.aniK_msg2')}</div>
                    <div className="msg-title3">{t('delta2.aniK_msg3')}</div>
                </div>
                <div className="video-box">
                    <div className="msg-desc">
                        <div className="desc1">{t('delta2.aniK_msg4')}</div>
                        <div className="desc2">{t('delta2.aniK_msg5')}</div>
                        {supportLinkLocales.includes(locale) && (
                            <Link href="/app" className="link_learn" newWin>
                                <div className="text2">{t('delta2.learn_more')}</div>
                                <div className="icon">
                                    <EFAppArrow />
                                </div>
                            </Link>
                        )}
                    </div>
                    <EFVideo className="video" sources={[`/media/delta2/pc/animK_${imageLocal}.webm`, `/media/delta2/pc/animK_${imageLocal}.mp4`]} />
                </div>
            </div>
        </div>
    );
};

export default AppControl;
